import React from 'react';

function StatCard({ label, value, valueClass }) {
  return (
    <div className="bg-white rounded-[12px] border border-[#EFF0F6] p-[24px] flex flex-col gap-[8px]" style={{ boxShadow: '0px 1px 8px 0px #14142B0A' }}>
      <p className={`font-inter font-500 text-[16px] leading-none ${valueClass || 'text-[#141415]'}`}>
        {value}
      </p>
      <p className="max-w-[90px] font-inter text-[12px] text-[#45464EBF] leading-snug">{label}</p>
    </div>
  );
}

export default function MockStatWidgets({ mockStats }) {
  if (!mockStats) return null;

  const { hasData, totalMocksTaken, improvementSinceFirst, bestFullMock, avgFullMock } = mockStats;

  const totalDisplay = hasData ? String(totalMocksTaken) : '0';
  const bestDisplay = hasData && bestFullMock != null ? `${bestFullMock.toFixed(2)}%` : '—';
  const avgDisplay = hasData && avgFullMock != null ? `${avgFullMock.toFixed(2)}%` : '—';

  let improvDisplay = '—';
  let improvClass = 'text-[#141415]';
  if (hasData && improvementSinceFirst) {
    improvDisplay = improvementSinceFirst.display;
    improvClass = improvementSinceFirst.isPositive ? 'text-[#06A561]' : 'text-[#F0142F]';
  }

  return (
    <div className="grid grid-cols-2 gap-[24px]">
      <StatCard label="Full Mock Exams Taken" value={totalDisplay} />
      <StatCard
        label="Improvement since first mock"
        value={improvDisplay}
        valueClass={improvClass}
      />
      <StatCard label="Best Full Mock" value={bestDisplay} />
      <StatCard label="Avg Full Mock" value={avgDisplay} />
    </div>
  );
}
